module.exports = __webpack_public_path__ + "src/assets/games/6/feiji3.png";